import { useEffect, useState } from 'react';
import { Tabs } from 'antd';

import { ContributedOffers } from './ContributedOffers';
import { OfferItems } from './OfferItems';
import { OfferMatches } from './OfferMatches';

import { offerStore } from '../../store';

export const OfferTabs = () => {
  const selectItems = offerStore((state) => state.selectItems);

  const [items, setItems] = useState([{
    label: 'Offer Matches',
    children: <OfferMatches />,
  }, {
    label: 'Contributed Offers',
    children: <ContributedOffers />,
  }].map((item, index) => ({
    ...item,
    key: String(index + 1),
  })));

  useEffect(() => {
    if (selectItems?.length) {
      setItems((prevState) => [{
        label: 'Offer Items',
        children: <OfferItems />,
      }, ...prevState].map((item, index) => ({
        ...item,
        key: String(index + 1),
      })));
    }
  }, [selectItems]);

  return (
    <Tabs
      size='large'
      items={items}
    />
  );
};
